import React, { useEffect, useRef } from "react";
import { trackAdView } from "@/lib/api";

const WINDOW_MS = 30 * 60 * 1000;
const seenKey = (id) => `verb_adview_${id}`;

// Reports an ad view only after the element is >=50% visible for >=1s; at most once per ad per 30 min from this browser
// (the server applies the same 30-min rule per visitor).
export function useAdView(ref, adId, pincode, placement) {
  useEffect(() => {
    const el = ref.current;
    if (!el || !adId || !pincode || typeof IntersectionObserver === "undefined") return undefined;
    let timer = null;
    let done = false;
    const recent = () => { try { return Date.now() - Number(localStorage.getItem(seenKey(adId)) || 0) < WINDOW_MS; } catch { return false; } };
    const io = new IntersectionObserver(([e]) => {
      if (done) return;
      if (e.isIntersecting && e.intersectionRatio >= 0.5 && !document.hidden) {
        if (!timer) timer = setTimeout(() => {
          done = true;
          io.disconnect();
          if (recent()) return;
          try { localStorage.setItem(seenKey(adId), String(Date.now())); } catch { /* storage blocked */ }
          trackAdView(adId, pincode, placement);
        }, 1000);
      } else { clearTimeout(timer); timer = null; }
    }, { threshold: [0, 0.5, 1] });
    io.observe(el);
    return () => { clearTimeout(timer); io.disconnect(); };
  }, [ref, adId, pincode, placement]);
}


// Wrapper for places that render an ad inline (e.g. Notifications list).
export function AdSeen({ adId, pincode, placement, children }) {
  const ref = useRef(null);
  useAdView(ref, adId, pincode, placement);
  return <div ref={ref}>{children}</div>;
}
